export {
  env,
  getProjectColorVariant,
  HIGHLIGHT_VARIANT,
  currentYear,
  isDate,
  isValidIncorporationDate,
  isEin,
  isPostalCode,
  convertSetToArray,
  formatCompanyName,
  isValidAmount,
  validateAmount,
  validateEmail,
  validateEin,
  validateEmailAddress,
  validateFullName,
  validateIfExist,
  validatePassword,
  validatePostalCode,
  validatePositiveInteger,
  validatePriorEntityDate,
  validateUrl,
  validateUsPhoneNumber,
  ZIndex,
  screenSm,
  screenMd,
  screenLg,
  screenXl,
  Breakpoints,
  COUNTRY_DICT_ALPHA2,
  COUNTRY_OPTIONS,
  getCountryCodeAlpha2,
  isAccountingFirmUser,
  isUrl,
  getFilteredQueryParams,
  downloadFileFromRemoteUrl,
  downloadFileByUrl,
  isLocalEnvironment,
  FilterSortDataType,
  makeFileAndUrl,
  escapeCsvValue,
  makeCsvFileAndUrl,
  stringifyCsv,
  compareArraysOfObjectsByProps,
  Path,
  paths,
  getPath,
  getPathUrl,
  type GetPathInput,
  getDefaultAscPath,
  getDefaultRdPath,
  getDefaultSredPath,
  formatDate,
  formatDateTime,
  isUserInactive,
  startTrackingUserInactivity,
  stopTrackingUserInactivity,
  clearThirdParties,
  makeButtonGroupFormConfig,
  makeCheckboxFormConfig,
  makeDropdownFormConfig,
  makeInputFormConfig,
  makeTextAreaFormConfig,
  makeYesNoFormConfig,
  makeMonthYearPeriodFormConfig,
  invertObjectKeyValue,
  makeMonthDatePickerFormConfig,
  calculateCount,
  calculateUniqueCount,
  calculateSum,
  calculateAverage,
  type UniqueCountOptions,
  periodDisplayName,
  calculatePercentageOfTotalCount,
  getExtendedErrorsOrDefault,
  initiateResumableFileUpload,
  type FilterField,
  advancedFilter,
  keywordFilter,
  toGqlPeriodName,
  interpretExcelParseError,
  interpretTabularDataParseError,
  formatContributorName,
  formatContributorNameWithEmail,
  type PeriodNameOption,
  type PeriodNameOptionGroup,
  generateAscPeriodOptions,
  getOperationName,
  removeProductSelectionFromLocalStorage,
  getFiscalYearSubsetPeriod,
  isYtdPeriodName,
  getCurrentValidYtdPeriodName,
  validateFile,
  isTestMode,
  isReCaptchaDisabled,
  getTicketingProviderName,
  bulkPriorYearTaxDocumentToDataSourcesTableItem,
  accountingTokenToDataSourcesTableItem,
  bulkTicketingFileUploadToDataSourcesTableItem,
  dataSourcesTableItemMapper,
  githubEmailMappingUploadToDataSourcesTableItem,
  syncedPayrollMonthExpenseToDataSourcesTableItem,
  timesheetUploadToDataSourcesTableItem,
  payrollTokenToDataSourcesTableItem,
  getDataSourceTypeLabel,
  dataSourceTableCellClassNames,
  syncedRdPayrollCostToDataSourcesTableItem,
  rdBusinessComponentUploadToDataSourcesTableItem,
  type DataSourcesTableItem,
  type ProviderUnion,
  type SyncedProviders,
  updateNonProjectTimePercent,
  updateProjectAllocationPercent,
  getProjectAllocationsForProjectPercents,
  allocationsHaveChanges,
  getTotalAllocationPercent,
  updateWithInputObject,
  sanitizeSameOriginPath,
  getValidSsoProviderId,
  deriveAuthContinueUrl,
  ENTERPRISE_SSO_REQUIRED_REASON,
  getForwardedAuthParams,
  getInvitationLoginPath,
  withForwardedAuthParams,
  rememberMagicLinkLogin,
  TicketingConnectionAction,
  TicketingConnectionStatus,
  toTicketingConnectionRows,
  type CompanyTicketingToken,
  type TicketingConnectionRow,
} from './utils';
export {
  wrapWithApolloProvider,
  apolloClient,
  evictCache,
  evictQres,
  evictAccountingAllocation,
  evictPayrollAllocation,
  evictCapitalizedAllocation,
} from './apollo';
export * from './assets';
export * from './graphql';
export {
  useCurrentCompanyId,
  useCurrentUser,
  useUserFromAuth,
  useCurrentCompany,
  useCurrentCompanyOrFail,
  useCompany,
  useCurrentCompanyIdOptional,
  useCompanies,
  useUrlQueryParam,
  useAuthContinueUrl,
  useDisableBodyScroll,
  useMergeDevAccounting,
  useSetLocationHashOnce,
  useIsMobile,
  useChangeBodyBackgroundColor,
  useMergeDevTicketing,
  useScript,
  useAllFiscalYears,
  useAllFiscalYearsOrFail,
  useCursorPaginatedQuery,
  useCsvFileUrl,
  useGetFederalDocumentStatuses,
  useGetLatestFederalDocumentStatusesForCompany,
  useCurrentUserScopeForCompany,
  useCurrentUserScopeForCurrentCompany,
  useBackgroundOperations,
  useLocalPersistedState,
  useUnfinishedSyncEventInPeriodByAnalysisType,
  useMounted,
  useSelectedProductOptional,
  useCompanyMembers,
  useFiscalYear,
  useFiscalYearOrFail,
  useSelectedFiscalYearId,
  useSelectedFiscalYearIdOptional,
  useOnboardingFlowStage,
  useCompanyInformation,
  useProviderTokensAndSyncedProviders,
  useDisabledProviders,
  useHasSkippedConnectingTicketing,
  useSticky,
  useCreateProduct,
  useProductOptions,
  useUpdateCompanyQuestion,
  useSelectedPeriodNameOptional,
  useProducts,
  useGitHubAppInstallReturn,
  useTicketingConnectModal,
  CONNECT_SLIDE_OVER_ACTIONS,
  useTicketingConnections,
  useDataSourcesTableColumns,
  useAlternatingText,
} from './hooks';
export {
  wrapWithInitializationHooks,
  wrapWithToastProvider,
  wrapWithAlertModalProvider,
  wrapWithVersionGuard,
  wrap,
  initializeThirdParties,
} from './initialization';
export {
  type Form,
  type FormSectionConfiguration,
  type FormInputValidator,
  type FormInputValidatorResult,
  type FormQuestionsInput,
  type CompanyQuestionsFormInput,
  type CheckboxFormType,
  type DropdownFormType,
  type InputFormType,
  type TextAreaFormType,
  type YesNoFormType,
  FormAlertCard,
  FormProgressAlertCard,
  FormItemFactory,
  FormSections,
  FormType,
  YesNo,
  toBoolean,
  getProgress,
  toYesNoEnum,
  HighlightText,
  RightColumnCard,
  Loader,
  type RedirectState,
  LaunchDarklyLoader,
  NavigateTo,
  useNavigateTo,
  NavLinkTo,
  OrganizationDashboardNav,
  SortPopover,
  useSorting,
  type Sorting,
  Blocker,
  KeywordSearch,
  useKeywordSearch,
  PageContainer,
  PageContentContainer,
  PageContent,
  LockedRegion,
  PageLayout,
  usePageLocked,
  type PageLayoutProps,
  SideNav,
  type SideNavProps,
  type SideNavItemProps,
  saveQuestions,
  ProviderLogo,
  type Conditions,
  type ConditionRow,
  FilterPopover,
  useFilterConditions,
  type ColumnDefinition,
  OperatorName,
  KeywordEmphasis,
  type SortValueMapper,
  makeSortComparator,
  makeFilterOperator,
  noopFormSubmit,
  CsvUploadInstructions,
  DocumentStatusBadge,
  GroupedVirtualizedList,
  ScrollableUnorderedList,
  MonthYearPicker,
  ControlledMonthYearPicker,
  defaultMonthOptions,
  ColumnVisibilityPopover,
  type ColumnVisibilityState,
  useColumnVisibility,
  SideDrawerSkeleton,
  ProjectLeftBar,
  ProjectName,
  MergeProjectsModal,
  ProjectCreationModal,
  ProjectsTable,
  VirtualizedList,
  MenuItem,
  MenuItemDivider,
  PercentCell,
  AllocationModal,
  type PerProjectAllocation,
  AllocationStyledModal,
  AllocationSlider,
  DeleteConfirmationLayout,
  type KeywordSearchState,
  type SortingState,
  type FilterState,
  BulkAllocationModal,
  ConnectProvidersModal,
  ProjectEligibilityModal,
  DeleteProductModal,
  UpdateProductModal,
  ProjectTeamMembersTable,
  Menu,
  GroupedTicketsBase,
  type GroupedTicketsComponentProps,
  NOISE_REASONING_PREFIX,
  type TicketRowTicketType,
  TicketGroupingList,
  OneSchemaWrapper,
  GithubEmailMappingSection,
  GithubEmailMappingUploadModal,
  useGithubEmailMappingData,
  GITHUB_EMAIL_MAPPING_TEMPLATE_KEY,
  DeleteFiscalYearProvider,
  DataSourceSection,
  TicketingConnections,
  DeleteTicketingFileUpload,
  OneSchemaModal,
  OneSchemaTimesheetModal,
  TicketingFileUploadModal,
  AnalysisInfo,
  GetStartedHero,
  OnboardingFlowProcessingHero,
  SourcesContent,
  TableHeader,
} from './organisms';
export {
  type AnalyticIdOptions,
  VersionGuardState,
  ToastConfigState,
  AuthenticationState,
  useAuthenticationService,
  AlertModalState,
  FileUploadsState,
  useAnalyticId,
  type ResumableFileUpload,
} from './state';
export * from './third-parties';
export { reactiveVarOrchestrator } from './orchestrators';
export {
  TABLE_CELL_PLACEHOLDER,
  RD_HELP_URL,
  NAV_HEIGHT,
  PAYROLL_PROVIDER_NAMES,
  PAYROLL_PROVIDER_FLAGS,
  ACCOUNTING_PROVIDER_NAMES,
  ACCOUNTING_PROVIDER_FLAGS,
  EMAIL_TO_SUPPORT_URL,
  STATE_OPTIONS,
  TICKETING_PROVIDER_NAMES,
  TICKETING_PROVIDER_FLAGS,
  COMPANY_ELEVATOR_PITCH_HELP_TEXT,
  COMPANY_ELEVATOR_PITCH_PLACEHOLDER,
  COMPANY_URL_HELP_TEXT,
  DEFAULT_MONGO_DB_YEAR,
  POLLING_INTERVAL_MS,
  HELP_PAGE_BASE_URL,
  HELP_CONNECT_PAYROLL_CSV_URL,
  HELP_UPLOAD_RD_PROJECT_DOCUMENTS_URL,
  HELP_FILL_OUT_RD_NARRATIVE_FIELDS_URL,
  HELP_INVITE_TEAM_MEMBERS_URL,
  HELP_EXPORT_TICKETS_URL,
  HELP_PROJECT_DISALLOWANCES_URL,
  GENERATING_ELEVATOR_PITCH_TEXTS,
} from './constants';
export type {
  AdditionalFormConfigOptions,
  LocalPersistenceKey,
  QuestionSection,
  Question,
  QuestionChoice,
  TaxDocument,
  FederalRdTaxCreditDocuments,
  AllocationsInPeriod,
  ProjectAllocationBase,
  ProjectPercents,
} from './types';
export { TaxDocumentSchema, FederalRdTaxCreditDocumentsSchema } from './types';
export { AuthType, NonSsoSignInMethod, LocalStorageKey, AuthErrorType, OnboardingFlowStage, NavSection } from './enums';
